import { createSelector } from 'reselect';
import { IWicAgenciesState, IWicAgencyItem } from './types';

export const selectWicAgencies = (state: IWicAgenciesState) => state.wicAgencies;

export const selectIndexedTenders = createSelector(selectWicAgencies, (wicAgencies) =>
  wicAgencies.reduce((indexed: { [key: string]: IWicAgencyItem }, wicAgency: IWicAgencyItem) => {
    if (wicAgency.stateIdentifierCode) {
      indexed[wicAgency.stateIdentifierCode] = wicAgency;
    }
    return indexed;
  }, {})
);
